import React from 'react';
import { WIcon } from '@warp-ds/components/react/icon';

interface ExternalDataEntryProps {
  label: string;
  value: string;
  iconClass: string;
}

export default function ExternalDataEntry({
  label,
  value,
  iconClass,
}: ExternalDataEntryProps) {
  return (
    <span data-testid="externalDataEntry">
      <div className="inline-block ml-8">
        {iconClass === 'favorite' ? (
          <WIcon name="Heart" size="small" style={{ position: 'relative', top: '1px' }} />
        ) : (
          <WIcon name="Cursor" size="small" style={{ position: 'relative', top: '1px' }} />
        )}
      </div>
      <span className="button__text sr-only">{label}</span>
      <div
        className="inline-block text-xs ml-4"
        style={{ position: 'relative', top: '-2px' }}
      >
        {value}
      </div>
    </span>
  );
}
